import { render } from "./Pondering.vue?vue&type=template&id=37e354e4"
import script from "./Pondering.vue?vue&type=script&lang=js"
export * from "./Pondering.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__